<template>
<form @submit.prevent="submit" autocomplete="off">

  <ui-alert type="error" v-for="e,index in errors" :key="index" @dismiss="dismissErrors()">{{ e }}</ui-alert>

  <ui-textbox label="E-mail" name="email" type="text" :autofocus="autofocus" v-model="item.email" validation-rules="required|email" :validation-messages="errorMessages" placeholder="Wpisz e-mail"></ui-textbox>
  <ui-textbox label="Imię" name="first_name" type="text" v-model="item.first_name"  validation-rules="required" :validation-messages="errorMessages" placeholder="Wpisz imię"></ui-textbox>
  <ui-textbox label="Nazwisko" name="last_name" type="text" v-model="item.last_name" validation-rules="required" :validation-messages="errorMessages" placeholder="Wpisz nazwisko"></ui-textbox>
  <div v-if="! this.item.id">
    <ui-textbox label="Hasło" name="password" type="password" v-model="item.password" validation-rules="required" :validation-messages="errorMessages" placeholder="Wpisz hasło"></ui-textbox>
    <ui-textbox label="Hasło (wpisz ponownie)" name="password2" type="password" v-model="item.password2" validation-rules="required" :validation-messages="errorMessages" placeholder="Wpisz hasło ponownie"></ui-textbox>
  </div>

  <div class="form-actions">
    <ui-button color="primary">{{ item.id ? 'Aktualizuj' : 'Dodaj' }}</ui-button>
  </div>
</form>

</template>
<script>
import Loading from '../../mixins/Loading'
import Notify from '../../mixins/Notify'
import FormErrors from '../../mixins/FormErrors'
import Utils from '../../services/Utils'

import Users from './../../services/Users'

export default {
  mixins: [Loading, Notify, FormErrors],
  props: {
    item: {
      type: Object, default: Users.getBaseItem()
    }
  },
  data () {
    return {
      autofocus: true,
      errors: [],
      title: 'Dodaj administratora',
      action: 'Dodaj administratora',
      errorMessages: Utils.errorMessages(['required', 'min', 'numeric', 'email'])
    }
  },
  mounted () {
    if (this.item.id) {
      this.title = 'Aktualizuj administratora'
      this.action = 'Aktualizuj administratora'
    }
  },
  methods: {
    resetForm () {
      this.item = Users.getBaseItem()
    },
    error (err) {
      this.errors = this.getResponseErrors(err)

      this.notify('Wystąpiły błędy, sprawdź poprawność wpisanych danych')
    },
    success (res) {
      if (this.item.id) {
        if (res.status === 200) {
          this.$emit('users.update', this.item)
          this.notify('Zmieniłeś administratora')
          this.$router.push({name: 'admin.users.show', params: {id: this.item.id}})
        }
      } else {
        if (res.status === 201) {
          this.$emit('users.create', this.item)
          this.notify('Dodałeś administratora')
          this.$router.push({name: 'admin.users.show', params: {id: res.data.item.id}})
        }
      }
    },
    submit () {
      let item = {}
      item.first_name = this.item.first_name
      item.last_name = this.item.last_name
      item.email = this.item.email
      item.status = this.item.status

      if (this.item.id) {
        item.id = this.item.id
      } else {
        item.password = this.item.password
        item.password2 = this.item.password2
      }

      if (this.item.id) {
        Users.update(item).then(this.success, this.error)
      } else {
        Users.create(item).then(this.success, this.error)
      }
    }
  }
}

</script>


// WEBPACK FOOTER //
// Form.vue?218e7a55